import {
    getCountries,
    getCountryCallingCode,
    parsePhoneNumberFromString,
} from 'libphonenumber-js'

export const DEFAULT_PHONE_COUNTRY = 'IL'

// E.164: "+", country code, up to 15 digits
const INTERNATIONAL_PHONE_REGEX = /^\+[1-9]\d{1,14}$/

const getFlag = (country) =>
    String.fromCodePoint(
        ...[...country].map((letter) => 0x1f1e6 + letter.charCodeAt(0) - 65)
    )

const getCountryNames = (locale) => {
    try {
        return new Intl.DisplayNames([locale], {type: 'region'})
    } catch (_) {
        return null
    }
}

export const getPhoneCountries = (locale) => {
    const countryNames = getCountryNames(locale)
    return getCountries()
        .map((country) => ({
            country,
            name: countryNames?.of(country) || country,
            flag: getFlag(country),
            callingCode: `+${getCountryCallingCode(country)}`,
        }))
        .sort((a, b) => a.name.localeCompare(b.name, locale))
}

// splits a stored "+972542111079" into the country and the number without the country code
export const splitPhone = (phone) => {
    const parsedPhone = phone && parsePhoneNumberFromString(phone)
    if (!parsedPhone) {
        return {country: DEFAULT_PHONE_COUNTRY, number: phone || ''}
    }
    const country =
        parsedPhone.country ||
        getCountries().find(
            (c) => getCountryCallingCode(c) === parsedPhone.countryCallingCode
        ) ||
        DEFAULT_PHONE_COUNTRY
    return {country, number: parsedPhone.nationalNumber}
}

// returns the phone in international format, '' when empty, or null when invalid
export const joinPhone = (country, number) => {
    if (!number?.trim()) {
        return ''
    }
    const parsedPhone = parsePhoneNumberFromString(number, country)
    if (
        !parsedPhone?.isPossible() ||
        !INTERNATIONAL_PHONE_REGEX.test(parsedPhone.number)
    ) {
        return null
    }
    return parsedPhone.number
}
